import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element' // IE polyfill
Vue.use(vueCustomElement)

import VVehicles from './VVehicles/VVehicles.vue'

Vue.customElement('v-vehicles', VVehicles)
